import * as React from 'react';
import { Ref, forwardRef } from 'react';
const SvgCollapseAll = (_, ref: Ref<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 16 16"
    height={_.height}
    width={_.width}
    className={_.className}
    role={_.role}
    aria-label={_.ariaLabel}
    aria-hidden={_.ariaHidden}
    ref={ref}
  >
    <rect width={8} height={1.5} y={3} fill={_.color} rx={0.75} />
    <rect width={8} height={1.5} y={7} fill={_.color} rx={0.75} />
    <rect width={8} height={1.5} y={11} fill={_.color} rx={0.75} />
    <path
      fill={_.color}
      fillRule="evenodd"
      d="M10.193 9.79a.77.77 0 0 1 0-1.02l2.341-2.56a.62.62 0 0 1 .932 0l2.341 2.56a.77.77 0 0 1 0 1.02.62.62 0 0 1-.931 0L13 7.737 11.124 9.79a.62.62 0 0 1-.931 0"
      clipRule="evenodd"
    />
  </svg>
);
const ForwardRef = forwardRef(SvgCollapseAll);
export default ForwardRef;
